import script from "./CongesCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./CongesCalendar.vue?vue&type=script&setup=true&lang=js"

import "./CongesCalendar.vue?vue&type=style&index=0&id=ae53131c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae53131c"]])

export default __exports__